import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export default function VariantSelectionModal({ isOpen, onClose, product, onSelectVariant }) {
  if (!product || !product.variants) return null;

  const handleSelect = (variant) => {
    onSelectVariant({
      ...product,
      sku: variant.sku,
      price: variant.price,
      variantName: variant.name,
      image: variant.image || product.image,
      price_id: variant.price_id
    });
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[95vw] w-[95vw] max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl mb-4">Select Variant - {product.name}</DialogTitle>
        </DialogHeader>
        
        {/* Grid with 8-10 items per row, smaller images */}
        <div className="grid grid-cols-8 lg:grid-cols-10 gap-3 mt-2">
          {product.variants.map((variant, index) => (
            <button
              key={variant.sku || index}
              onClick={() => handleSelect(variant)}
              className="flex flex-col items-center p-3 rounded-lg border-2 border-gray-200 hover:border-primary hover:shadow-lg transition-all bg-white"
            >
              {variant.image && (
                <div className="w-full aspect-square mb-2 rounded overflow-hidden bg-gray-100">
                  <img 
                    src={variant.image} 
                    alt={variant.name} 
                    className="w-full h-full object-cover" 
                  />
                </div>
              )}
              <div className="text-center w-full">
                <p className="font-semibold text-sm mb-1 line-clamp-2">{variant.name}</p>
                <p className="text-lg font-bold text-primary">${variant.price.toFixed(2)}</p>
              </div>
            </button>
          ))}
        </div>
        
        <div className="mt-6 pt-4 border-t flex justify-end">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
